'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _linksoftAlbatros = require('linksoft-albatros');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function closeOtherOpenedDropdowns() {
  (0, _jquery2.default)('.dropdown.open', document).removeClass('open');
}

(0, _jquery2.default)(document).on('click', '.dropdown-toggle', function (e) {
  var $toggle = (0, _jquery2.default)(this);

  // minicart go to detail
  if (!(0, _linksoftAlbatros.isMaxWidth)('md') && $toggle.hasClass('dropdown-toggle--click')) {
    // let link to cart
  } else {
    e.preventDefault();
  }

  var $parent = $toggle.parent();

  if ($parent.hasClass('open')) {
    $parent.removeClass('open');
  } else {
    closeOtherOpenedDropdowns();

    // using .parents('.dropdown') is for situation that dropdown is inside
    // another dropdown, like 3rd child menu
    $toggle.parents('.dropdown').addClass('open');
  }
});

// event close dropdown when click outside dropdown
(0, _jquery2.default)(document).on('click', function (e) {
  if ((0, _jquery2.default)(e.target).closest('.dropdown').length) {
    return;
  }

  closeOtherOpenedDropdowns();
});


//////////////////
// WEBPACK FOOTER
// ./~/linksoft-albatros/src/plugins/dropdown.js
// module id = 957
// module chunks = 0